import { LIMITS } from './codes';

export type NormalizedUrl = { ok: true; value: string } | { ok: false };

// Mesma regra do BE (contract/url.js): só http/https, sem esquema ganha https://,
// caminho relativo é rejeitado, exige host e proíbe credenciais na URL.
export function normalizeExitUrl(value: unknown): NormalizedUrl {
  if (typeof value !== 'string') return { ok: false };

  const trimmed = value.trim();
  if (trimmed === '' || trimmed.length > LIMITS.URL_MAX) return { ok: false };

  let candidate: string;
  const scheme = trimmed.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):/);
  if (scheme) {
    const name = scheme[1].toLowerCase();
    if (name !== 'http' && name !== 'https') return { ok: false };
    candidate = trimmed;
  } else if (trimmed.startsWith('//')) {
    candidate = `https:${trimmed}`;
  } else if (trimmed.startsWith('/')) {
    return { ok: false };
  } else {
    candidate = `https://${trimmed}`;
  }

  try {
    const parsed = new URL(candidate);
    if (!parsed.hostname) return { ok: false };
    if (parsed.username || parsed.password) return { ok: false };
  } catch {
    return { ok: false };
  }

  if (candidate.length > LIMITS.URL_MAX) return { ok: false };
  return { ok: true, value: candidate };
}
